
import TransitionAccordion from '~/components/transitions/TransitionAccordion'
import NavigationMenuItems from '~/assets/data/navigation'

export default {
  name: 'DashboardMenu',
  components: { TransitionAccordion },
  props: {
    isMobile: Boolean,
    menuCollapsed: Boolean
  },
  data () {
    return {
      subMenu: 0
    }
  },
  computed: {
    menuItems () {
      return NavigationMenuItems.filter((item) => {
        return typeof item.hasPermission === 'undefined' || item.hasPermission(this.$auth.user)
      })
    }
  },
  watch: {
    '$route' () {
      if (this.isMobile) {
        this.$emit('close')
      }
    }
  },
  mounted () {
    this.menuItems.forEach((item, index) => {
      if (!item.sections) {
        return
      }

      item.sections.forEach((section) => {
        const activeSubNav = section.items.find((item) => {
          return item.route.name === this.$route.name
        })

        if (activeSubNav) {
          this.toggleSubNav(index)
        }
      })
    })
  },
  methods: {
    toggleSubNav (index) {
      this.subMenu = this.subMenu === index ? null : index
    }
  }
}
